import { useTranslation } from "react-i18next";
import { DateUtils } from "../../../../../utils";
import './ChangeEmailCard.scss';
import { useHistory } from "react-router-dom";

export const ChangeEmailCard = ({
  procedure, petition, hasAction = true
}) => {
  const {t} = useTranslation();
  const history = useHistory();
  const clickable = hasAction && ['PENDING', 'DATA_COMPLETED', 'REGISTERED'].includes(procedure.status);

  const success = procedure.verified === 'SUCCESS' || procedure.verified === undefined;

  return (
    <button key={procedure.id} className="ChangeEmailCard" type="button"
      onClick={clickable ? () => {
        if (procedure.status === 'REGISTERED') history.push(`/petitions/${petition.petitionId}/change-email/${procedure.id}`, {
          petition: petition
        })
        else history.push(`/petitions/${petition.petitionId}/change-email/new`, {
          changeEmail: true, procedureId: procedure.id, petition
        })
      } : null}
    >
      <span className="sr-only">{t('Globals.seeRequest')}</span>
      <div className="ChangeEmailCard-container">
        <img 
          className='icon-left'
          src={procedure.status === 'REGISTERED' && success === true ? "/misc/icons/step-ok.png" : "/misc/icons/status-pendingDoc.png"}
        />
        <div className="document-data">
          <div className="document-data-row">
            <div className="document-column">
              <p className="document-column-title">{t('Petitions.ChangeEmail.ChangeEmailList.status')}</p>
              <p className="document-column-value">{procedure.statusTitle}</p>
            </div>
            <div className="document-column">
              <p className="document-column-title">{t('Petitions.ChangeEmail.ChangeEmailList.creationDate')}</p>
              <p className="document-column-value">{DateUtils.getFormatedDate(procedure.creationTime)}</p>
            </div>
            <div className="document-column">
              <p className="document-column-title">{procedure.status === 'REGISTERED' ? t('Petitions.ChangeEmail.ChangeEmailList.presentationDate') : t('Petitions.ChangeEmail.ChangeEmailList.updateTime')}</p>
              <p className="document-column-value">{DateUtils.getFormatedDate(procedure.statusTime)}</p>
            </div>
            {
              procedure.registerNumber && (
                <div className="document-column">
                  <p className="document-column-title">{t('Petitions.ChangeEmail.ChangeEmailList.registerNumber')}</p>
                  <p className="document-column-value">{procedure.registerNumber}</p>
                </div>
              )
            }
          </div>
        </div>
      </div>
      {
        !success && (
          <div className="change-email-warning">
            <span>
              {t("Petitions.ChangeEmail.ChangeEmailList.pending")}
            </span>
          </div>
        )
      }
    </button>
  );
}